import React from "react";
import classes from "./header.module.css";
import { config } from "../../config";
import { Container, Navbar, Nav, NavDropdown, Dropdown } from "react-bootstrap";
import NavProfile from "./nav_profile";
import NavBarcode from "./nav_barcode";
import NavWeightCode from "./nav_weightcode";
import NavWeightCodeKeyboard from "./nav_weightcode_keyboard";
import NavAddGoodByBarcode from "./nav_add_good_by_barcode";
import NavAddGoodByBarcodeKeyboard from "./nav_add_good_by_barcode_keyboard";
import NavAddGood from "./nav_add_good";
// import NavReceiptList from "./nav_receiptlist";
import NavReceiptsList from "./AppsMain/NavReceiptsList/NavReceiptsList";
import CashList from "./nav_cashlist";
import NavDiscount from "./nav_discount";
// import NavChecklistReturn from "./nav_checklist_return";
import NavClearProducts from "./nav_clear_products";
import NavPrices from "./nav_prices";
import { useSelector, shallowEqual } from 'react-redux';
import NavReceiptsOrders from "./AppsMenu/NavReceiptsOrders/NavReceiptsOrders";
import NavReceiptsPostponed from "./AppsMenu/Postpone/NavReceiptsPostponed/NavReceiptsPostponed";
import NavReceiptPostpone from "./AppsMenu/Postpone/NavReceiptPostpone/NavReceiptPostpone";
import NavZReportsVchasno from "./AppsMenu/NavZReportsVchasno/NavZReportsVchasno"
import NavFiscLogs from "./AppsMenu/NavFiscLogs/NavFiscLogs"
import MenuIcon from "../../images/menu-kebab-tiny.svg";

function Header() {
  const checkData = useSelector(
    (state) => state.actions.checkData,
    shallowEqual
  );
  return (
    <header>
      <Navbar bg="light">
        <Container fluid>
          <Nav>
            {/* <NavBarcode /> */}
            {!checkData || !checkData.cashierWorkplace || checkData.cashierWorkplace.showNumericKeyborad !== 1 && <NavAddGoodByBarcode />}
            {checkData && checkData.cashierWorkplace && checkData.cashierWorkplace.showNumericKeyborad === 1 && <NavAddGoodByBarcodeKeyboard />}
            <NavAddGood />
            {(checkData?.cashierWorkplace?.showWeightCodeSearch && (!checkData || !checkData.cashierWorkplace || checkData.cashierWorkplace.showNumericKeyborad !== 1)) === true && <NavWeightCode />}
            {(checkData?.cashierWorkplace?.showWeightCodeSearch && (checkData && checkData.cashierWorkplace && checkData.cashierWorkplace.showNumericKeyborad === 1)) === true && <NavWeightCodeKeyboard />}
            <NavPrices />
            <NavReceiptsList frId={checkData?.cashierWorkplace?.fiscalRegistrarId} fiscalRegistrars={checkData?.shift?.fiscalRegistrars} />
            <CashList checkData={checkData} />
            {checkData && checkData.cashierWorkplace && checkData.cashierWorkplace.useManualDiscounts === 1 && <NavDiscount />}
            <NavClearProducts />
            {checkData && checkData.userData && checkData.userData.rolesSeniorCashier === 1 && <NavAddGood priceEdit={true} />}
            {/* <NavChecklistReturn /> */}
            {/* {checkData?.cashierWorkplace?.webOrdersHandling === 1 && <NavReceiptsOrders frId={checkData?.cashierWorkplace?.fiscalRegistrarId ?? 0} />} */}
          </Nav>
          <Nav>
            <NavDropdown
              className={classes.nav_dropdown}
              align="end"
              title={
                <div className={classes.profile_icon}>
                  <img className={classes.menu_icon} src={MenuIcon} alt="barcode" />
                </div>
              }
              onClick={(e) => {
                e.target.blur();
              }}
            >
              <NavDropdown.Item style={{ paddingLeft: "0px" }}>
                <NavReceiptPostpone />
              </NavDropdown.Item>
              <NavDropdown.Item style={{ paddingLeft: "0px" }}>
                <NavReceiptsPostponed />
              </NavDropdown.Item>
              {checkData?.cashierWorkplace?.webOrdersHandling === 1 &&
                <NavDropdown.Divider />
              }
              {checkData?.cashierWorkplace?.webOrdersHandling === 1 &&
                <NavDropdown.Item style={{ paddingLeft: "0px" }}>
                  <NavReceiptsOrders />
                </NavDropdown.Item>
              }
              {config.showZReportsVchasno &&
                <NavDropdown.Divider />
              }
              {config.showZReportsVchasno &&
                <NavDropdown.Item style={{ paddingLeft: "0px" }}>
                  <NavZReportsVchasno fiscalRegistrars={checkData?.shift?.fiscalRegistrars ?? []} />
                </NavDropdown.Item>
              }
              <NavDropdown.Divider />
              <NavDropdown.Item style={{ paddingLeft: "0px" }}>
                <NavFiscLogs />
              </NavDropdown.Item>
            </NavDropdown >
            <NavProfile />
          </Nav>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
